var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenuAnalysisChatGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#86888C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.9,152.7H91c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1h317.9c3.9,0,7.1,3.2,7.1,7.1S412.9,152.7,408.9,152.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M311.6,263.9H91c-3.9,0-7.1-3.2-7.1-7.1s3.2-7.1,7.1-7.1h220.6c3.9,0,7.1,3.2,7.1,7.1S315.6,263.9,311.6,263.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.8,486c-10.5,0-19.6-8.7-19.6-18.5v-79.1c-14.8-1.5-28.4-8.5-38.2-19.5c-11-12.3-17-29-17-47.1V81 c0.1-37.1,30.1-67,67.1-67.1h365.7c37,0.1,67,30.1,67,67.1v240.7c-0.1,37-30,67-67.1,67.1H150.8c-10.6,15.8-56.5,83.8-59.2,87.8 C86.2,484.4,79.5,486,74.8,486z M67.1,28.2C38,28.2,14.3,51.9,14.3,81v240.6c0,30.6,20.2,52.8,48,52.8c3.9,0,7.1,3.2,7.1,7.1v85.8 c0,1.6,2.5,4.3,5.3,4.3c1.4,0,3-0.4,4.9-3.2c3.1-4.5,60.7-90,61.3-90.9c1.4-2,3.6-3.1,5.9-3.1h286c29.2-0.1,52.7-23.7,52.7-52.8V81 c0-29.2-23.7-52.7-52.8-52.8L67.1,28.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuAnalysisChatGray);
export default __webpack_public_path__ + "static/media/ic-menu-analysis-chat-gray.39ab5f967295af7df7cb62ef81f1be92.svg";
export { ForwardRef as ReactComponent };